import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import ModalBottomSheetUI from '../../../components/UI/ModalBottomSheetUI';

const ButtonsInfo = (props) => {
    const [info, setInfo] = useState({ preloader: true, open: false });

    const closeModal = () => {
        info.open = false;
        setInfo({ ...info });
    }


    const renderInfo = (item, index) => {
        return (
            <li
                key={`${index}`}
                className="collection-item"
                style={{ color: 'black' }}
            >
                <div key={`${item.id}-div`}>
                    <div className="row" style={{ marginBottom: '0px', wordWrap: 'break-word' }}>
                        <span className="col s12" style={{ fontWeight: 'bold', padding: '0px' }}>{`${item.partNumberCode}: ${parseInt(item.qtStorage)} caixas x ${item.qtItems} peças`}</span>
                    </div>
                </div>
            </li>
        )
    }


    return (
        <>
            <div style={{ float: 'right', marginRigth: '40px' }}>
                <i
                    className="material-icons"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        props.clearReceiptsGroup();
                    }}>delete
                </i>
            </div>
            <div style={{ float: 'right', marginRigth: '20px' }}>
                <i
                    className="material-icons"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        info.open = info.open ? false : true;
                        setInfo({ ...info })
                    }}>info
                </i>
            </div>
            <ModalBottomSheetUI
                open={info.open}
                maxHeight="65%"
                onClose={closeModal}
                data={
                    <ul className="col s12" style={{ padding: '0', marginTop: '0' }}>
                        {
                            props.receiptsGroup.map((item, index) => (
                                renderInfo(item, index)
                            ))
                        }
                    </ul>
                }
            />
        </>
    );

}

export default (withTranslation()(ButtonsInfo));